<div class="card watch-shell" [class.watch-shell--embedded]="!!parentComp">
	<ng-container *ngIf="loading">
		<p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
		<div class="p-text-center p-mt-3">{{ translateServ.dictionary['LOADING_JOURNAL_MOVES'] }}</div>
	</ng-container>

	<ng-container *ngIf="!loading && errorMessage">
		<div class="flex flex-column align-items-center justify-content-center h-20rem p-5">
			<div class="p-message p-message-error p-message-icon text-center"
				style="margin-bottom: 1rem; padding: 2rem; border-radius: var(--border-radius); width: 100%;">
				<i class="pi pi-times-circle text-6xl mb-3"></i>
				<div class="font-bold text-xl mb-3">{{ errorMessage }}</div>
				<button pButton type="button" icon="pi pi-refresh" label="{{ translateServ.dictionary['RETRY']}}"
					(click)="loadInvoices()" class="p-button-raised p-button-danger"></button>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="!loading && !errorMessage">
		<p-table #dt id="watch-journal-table"
			[styleClass]="'app-data-table app-data-table--paged watch-journal-table'"
			[paginator]="true"
			[value]="invoices" [scrollable]="!parentComp" [scrollHeight]="parentComp ? undefined : 'flex'" [totalRecords]="invoices.length"
			[responsiveLayout]="'scroll'" [tableStyle]="{'min-width': '1100px'}"
			[rows]="getCurrentPageSize(0,invoices.length)" [rowsPerPageOptions]="setPaginator(invoices.length)"
			[showCurrentPageReport]="true" currentPageReportTemplate="{{translateServ.dictionary['TAB_FOOTER_SHOWING']}} {first}
																{{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} 
																{{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} 
																{{ translateServ.dictionary['TAB_FOOTER_ENTRIES']}}" [globalFilterFields]="allColumnFields"
			dataKey="ID" [filterDelay]="0" [(selection)]="selectedInvoices" [selectionMode]="'multiple'"
			(onSort)="onTableSortOrFilter($event)" (onFilter)="onTableSortOrFilter($event)"
			(onPage)="onRowsPerPageChange($event, 0, invoices.length)"
			(onRowSelect)="onJournalCheckboxChanged($event, true)"
			(onRowUnselect)="onJournalCheckboxChanged($event, false)"
			(selectionChange)="onAllJournalCheckboxChanged($event)">
			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === invoices.length ? 'All' : item.value }}
			</ng-template>
			<ng-template pTemplate="caption">
				<div class="flex align-items-center justify-content-between">
					<h5 class="m-0">{{ translateServ.dictionary['JOURNAL_MOVES_TITLE'] }}</h5>
					<div class="flex align-items-center gap-2"
						[ngClass]="(directionServ.currentDirection$ | async) === 'ltr' ? 'ml-auto' : 'mr-auto'">
						<p-button type="button" icon="pi pi-filter-slash"
							label="{{ translateServ.dictionary['BTN_REMOVE_ALL_FILTERS'] }}"
							[styleClass]="hasActiveTableFilters ? 'p-button-sm' : 'p-button-outlined p-button-sm'"
							(click)="clearAllFilters(globalSearchInput)"></p-button>

						<p-button type="button"
							[label]="hideEmptyColumnsEnabled ? (translateServ.dictionary['BTN_SHOW_ALL_COL'] || 'Show All Columns') : (translateServ.dictionary['BTN_HIDE_EMPTY_COL'] || 'Hide Empty Columns')"
							[icon]="hideEmptyColumnsEnabled ? 'pi pi-eye' : 'pi pi-eye-slash'"
							[styleClass]="hideEmptyColumnsEnabled ? 'p-button-primary p-button-sm' : 'p-button-outlined p-button-sm'"
							(click)="toggleHideEmptyColumns()">
						</p-button>

						<p-button *ngIf="parentComp == null" type="button" icon="pi pi-download"
							[label]="translateServ.dictionary['EXPORT_MOVEIN_BTN']"
							[disabled]="!selectedInvoices || selectedInvoices.length === 0"
							[styleClass]="!selectedInvoices || selectedInvoices.length === 0 ? 'p-button-primary p-button-sm' : 'p-button-outlined p-button-sm'"
							(click)="exportMovein()">
						</p-button>

						<!-- Go to Last Viewed Button -->
						<p-button type="button" icon="pi pi-tag" styleClass="p-button-sm"
							label="{{ translateServ.dictionary['GO_TO_LAST_VIEWED'] || 'Go to Last Viewed' }}"
							(click)="goToLastViewed()">
						</p-button>

						<span class="p-input-icon-left ml-4">
							<i class="pi pi-search"></i>
							<input #globalSearchInput pInputText type="text"
								(input)="dt.filterGlobal($any($event.target).value, 'contains')"
								placeholder="{{ translateServ.dictionary['GLOBAL_SEARCH'] }}" />
						</span>
					</div>
				</div>
			</ng-template>

			<ng-template pTemplate="header">
				<tr>
					<th style="width: 3rem">
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<th style="width: 5rem; text-align: center;" [pSortableColumn]="'NotifCount'"
						pTooltip="{{ translateServ.dictionary['NOTIFICATIONS_COUNT'] || 'Notifications' }}">

						<i class="pi pi-bell"></i>
						<p-sortIcon [field]="'NotifCount'"></p-sortIcon>
					</th>

					<ng-container *ngFor="let colField of allColumnFields">
						<th *ngIf="columnVisibility[colField]" [pSortableColumn]="colField">
							{{ getColumnHeader(colField) }}
							<p-sortIcon [field]="colField"></p-sortIcon>
							<p-columnFilter type="text" [field]="colField" display="menu"></p-columnFilter>
						</th>
					</ng-container>
					<th>{{ translateServ.dictionary['JMT_COL_WATCH_N_EDIT'] }}</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-invoice>
				<tr [class.row-highlight]="isSelected(invoice)" [ngClass]="{'lastly-viewed-row': isLastViewed(invoice)}"
					(dblclick)="onRowDoubleClick({data: invoice})">
					<td>
						<p-tableCheckbox [value]="invoice"></p-tableCheckbox>
					</td>
					<td style="width: 5rem; text-align: center;">
						<p-tag [icon]="'pi pi-bell'" [value]="getNotificationTag(invoice).value"
							[severity]="getNotificationTag(invoice).severity" [rounded]="true"
							[pTooltip]="getNotificationTag(invoice).tooltip" (click)="openNotificationsDialog(invoice)"
							[style]="{'cursor': 'pointer'}"> </p-tag>
					</td>
					<ng-container *ngFor="let colField of allColumnFields">
						<td *ngIf="columnVisibility[colField]">
							<ng-container *ngIf="colField === 'MT'; else checkPratim">
								<p-tag [value]="getMtDisplayText(invoice.MT)"
									[severity]="getMtSeverity(invoice.MT)"></p-tag>
							</ng-container>

							<ng-template #checkPratim>
								<ng-container *ngIf="colField === 'Pratim'; else checkMisparOsekMurshe">
									<p-floatlabel pTooltip="{{invoice.Pratim}}">...</p-floatlabel>
								</ng-container>
							</ng-template>

							<ng-template #checkMisparOsekMurshe>
								<ng-container *ngIf="colField === 'Mispar_Osek_Murshe'; else checkKheshbonKhova1"> <span
										[pTooltip]="invoice.CustomerName" tooltipPosition="top">
										{{ getPreviewDisplayValue('Mispar_Osek_Murshe', invoice[colField]) }}
									</span>
								</ng-container>
							</ng-template>

							<ng-template #checkKheshbonKhova1>
								<ng-container *ngIf="colField === 'Kheshbon_Khova_1'; else checkKheshbonZkhut1"> <span
										[pTooltip]="invoice.Kheshbon_Khova_1_name" tooltipPosition="top">
										{{ getPreviewDisplayValue('Kheshbon_Khova_1', invoice[colField]) }}
									</span>
								</ng-container>
							</ng-template>

							<ng-template #checkKheshbonZkhut1>
								<ng-container *ngIf="colField === 'Kheshbon_Zkhut_1'; else defaultDisplay"> <span
										[pTooltip]="invoice.Kheshbon_Zkhut_1_name" tooltipPosition="top">
										{{ getPreviewDisplayValue('Kheshbon_Zkhut_1', invoice[colField]) }}
									</span>
								</ng-container>
							</ng-template>

							<ng-template #defaultDisplay>
								{{ getPreviewDisplayValue(colField, invoice[colField]) }} </ng-template>
						</td>
					</ng-container>
					<td>
						<button pButton icon="pi pi-eye" class="p-button-text p-button-sm"
							(click)="openPreview(invoice)" [disabled]="!invoice.URL"
							pTooltip="{{ translateServ.dictionary['JMT_TOOLTIP_PREVIEW'] }}"></button>
					</td>
				</tr>
			</ng-template>

			<ng-template pTemplate="emptymessage">
				<tr>
					<td [attr.colspan]="allColumnFields.length + 3">{{ translateServ.dictionary['NO_INVO_FOUND'] }}</td>
				</tr>
			</ng-template>
		</p-table>
	</ng-container>


	<!-- Notifications Dialog: placed at the end of the card for proper DOM context -->
	<app-notification-dialog [fileRecId]="currentInvoiceIdForNotification" [(visible)]="displayNotificationsDialog"
		(notificationSummaryChange)="onNotificationSummaryChange($event)">
	</app-notification-dialog>
</div>